export const ru = {
  app: {
    name: "Secure Mind",
    loading: "Загрузка",
    loadingSecurely: "Проверяем сессию",
    stale: "Обновляем",
    accessRemoved: "Доступ отозван",
  },
  nav: {
    focus: "Фокус",
    work: "Работа",
    graph: "Связи",
    documents: "Документы",
  },
  common: {
    create: "Создать",
    save: "Сохранить",
    cancel: "Отменить",
    retry: "Повторить",
    copy: "Копировать",
    close: "Закрыть",
    search: "Поиск",
    accept: "Принять",
    reject: "Отклонить",
    move: "Переместить",
  },
  auth: {
    common: {
      working: "Подождите…",
    },
    errors: {
      generic: "Не удалось выполнить действие",
      invalidLink: "Ссылка недействительна, истекла или уже использована",
      passwordMismatch: "Пароли не совпадают",
      passkeyUnavailable: "Этот браузер не поддерживает ключи доступа",
    },
    signIn: {
      title: "Войти в Secure Mind",
      description: "Личное пространство с защищённым доступом",
      passkey: "Войти с ключом доступа",
      passkeyHelp: "Подтвердите вход на этом устройстве или внешнем ключе",
      passwordDivider: "или войдите по паролю",
      email: "Электронная почта",
      password: "Пароль",
      passwordSubmit: "Войти",
      totpTitle: "Код подтверждения",
      totpHelp: "Введите шестизначный код из приложения-аутентификатора",
      totpCode: "Одноразовый код",
      verifyTotp: "Подтвердить код",
      useBackupCode: "Использовать резервный код",
      backupTitle: "Резервный код",
      backupHelp: "Введите один из сохранённых одноразовых резервных кодов",
      backupCode: "Резервный код",
      verifyBackup: "Подтвердить резервный код",
      useTotp: "Использовать код аутентификатора",
    },
    setup: {
      title: "Настройка владельца",
      loading: "Проверяем ссылку настройки",
      description: "Создайте защищённый способ входа. Публичной регистрации нет.",
      passkeyTitle: "Ключ доступа",
      passkeyHelp: "Рекомендуемый способ: подтверждение устройством без пароля",
      createPasskey: "Создать ключ доступа",
      passwordTitle: "Пароль и TOTP",
      passwordHelp: "Используйте пароль длиной не менее 12 символов и приложение-аутентификатор",
      password: "Пароль",
      confirmPassword: "Повторите пароль",
      continuePassword: "Продолжить с паролем",
      totpTitle: "Подключите приложение-аутентификатор",
      totpHelp: "Отсканируйте код локально или добавьте URI вручную, затем введите шестизначный код",
      totpCode: "Код из приложения",
      verifyTotp: "Завершить настройку",
      backupCodesTitle: "Сохраните резервные коды",
      backupCodesHelp: "Эти коды показываются один раз. Храните их отдельно от этого устройства.",
      retryTotp: "Получить новые параметры TOTP",
      expired: "Ссылка настройки истекла. Создайте новую ссылку на сервере.",
    },
    simulation: {
      title: "Режим симуляции",
      loading: "Проверяем одноразовую ссылку",
      description: "Secure Mind откроется с ограниченной личностью и разрешёнными пространствами",
      ready: "Симуляция подготовлена",
      conflictTitle: "Уже активна другая личность",
      conflictHelp: "Завершите текущий вход или симуляцию, прежде чем использовать эту ссылку",
      return: "Вернуться",
    },
  },
  identity: {
    simulation: "{{mock}} через {{actor}}",
    simulationNotice: "Вы работаете в режиме симуляции. Изменения не применяются.",
    stopSimulation: "Остановить симуляцию",
    exitSimulation: "Выйти из симуляции",
    recoveryTitle: "Обнаружены две активные личности",
  },
  readiness: {
    unpaired: "Не подключено",
    noGrant: "Нет доступа",
    offline: "Не в сети",
    modelUnavailable: "Ассистент недоступен",
    ready: "Готово",
    unavailable: "Недоступно",
  },
  shell: {
    primaryNavigation: "Основная навигация",
    hideNavigation: "Скрыть навигацию",
    showNavigation: "Показать навигацию",
    workspace: "Рабочее пространство",
    noWorkspace: "Нет рабочего пространства",
    settings: "Настройки",
    openSettings: "Аккаунт и настройки",
    accountAndWorkspace: "Аккаунт и пространство",
    account: "Аккаунт",
    effectiveAccount: "Текущий аккаунт",
    actorAccount: "Действующий владелец",
    readiness: "Доступ ассистента",
    modelObserved: "{{model}}",
    preferences: "Предпочтения",
    interfaceLanguage: "Язык",
    changeLanguage: "Сменить язык",
    locale: {
      ru: "Русский",
      en: "English",
    },
    reducedMotion: "Уменьшать движение",
    reducedMotionHint: "Учитывает настройки системы и аккаунта",
    simulationMode: "Режим симуляции",
    simulationPreferences: "Настройки аккаунта недоступны в симуляции",
    signOut: "Выйти",
  },
  workspaceGate: {
    title: "Создайте рабочее пространство",
    description: "Аккаунт готов. Создайте пространство для чатов, задач, связей и документов.",
    nameLabel: "Название пространства",
    namePlaceholder: "Например, Команда продукта",
    create: "Создать пространство",
    creating: "Создаём пространство…",
    simulationTitle: "В этой симуляции нет пространства",
    simulationDescription: "Создание пространства недоступно в этой симуляции. Выйдите из симуляции, чтобы вернуться к аккаунту.",
    exitSimulation: "Выйти из симуляции",
    exitingSimulation: "Выходим из симуляции…",
  },
  commandSearch: {
    eyebrow: "Пространство",
    title: "Поиск или команда",
    trigger: "Поиск или команда",
    inputLabel: "Поиск по пространству",
    placeholder: "Документы, задачи, чаты…",
    destinations: "Перейти",
    commandDescriptions: {
      focus: "Начать новый чат",
      work: "Открыть проекты и задачи",
      graph: "Посмотреть связи пространства",
      documents: "Открыть документы",
    },
    loading: "Ищем…",
    noResults: "Совпадений нет: «{{query}}».",
    error: "Поиск пространства недоступен.",
    archived: "В архиве",
    types: {
      note: "Заметка",
      project: "Проект",
      task: "Задача",
      document: "Документ",
      focus_thread: "Чат Focus",
      research_source: "Источник исследования",
      account: "Аккаунт",
    },
  },
  focus: {
    title: "Фокус",
    threads: "Чаты",
    notes: "Заметки",
    inbox: "Входящие",
    empty: "Пока ничего нет",
    compose: "Сообщение",
    organize: "Упорядочить",
    openInbox: "Открыть входящие",
    jumpLatest: "Последний ответ",
    sourceObserved: "Источник использован",
    awaitingQuery: "Проверьте поисковые запросы",
    noLeaseHeld: "Нет подключения к ассистенту",
    newThread: "Новый чат",
    newThreadAction: "Новый чат",
    showConnections: "Показать в связях",
    untitled: "Новый чат",
    emptyEyebrow: "Новый чат",
    emptyHeading: "Что хотите сделать?",
    emptyDescription: "Задайте вопрос или опишите задачу.",
    suggestionsLabel: "Примеры",
    suggestions: {
      plan: "Составь план",
      compare: "Сравни варианты и риски",
      summarize: "Сделай резюме и перечисли шаги",
    },
    suggestionUse: "Использовать пример",
    noWorkspace: "Выберите рабочее пространство.",
    history: "История чатов",
    historyAction: "История",
    closeHistory: "Закрыть",
    searchHistory: "Поиск по чатам",
    searchHistoryPlaceholder: "Найти чат…",
    search: "Найти",
    clearSearch: "Сбросить",
    historyEmpty: "Чаты не найдены.",
    historyNoResults: "По этому запросу чатов нет.",
    historyLoading: "Загружаем историю чатов…",
    historyError: "История чатов недоступна.",
    moreHistory: "Показать ещё",
    branch: "Ветка",
    threadDocument: "Сообщения",
    threadLoading: "Загружаем чат…",
    threadError: "Не удалось загрузить этот чат.",
    threadNotFound: "Чат не найден",
    threadNotFoundDescription: "Чат мог быть удалён или больше недоступен в этом пространстве.",
    backToHistory: "Назад к истории чатов",
    threadErrorDescription: "Чат мог быть перемещён или соединение прервалось.",
    messagesLoading: "Загружаем сообщения…",
    messagesError: "Не удалось загрузить сообщения.",
    retryThread: "Повторить загрузку чата",
    retryMessages: "Повторить загрузку сообщений",
    threadEmpty: "Сообщений пока нет.",
    loadOlder: "Загрузить более ранние сообщения",
    loadingOlder: "Загружаем…",
    assistant: "Ассистент",
    you: "Вы",
    currentRun: "Текущий ответ",
    runStatus: "Состояние: {{state}}",
    cancel: "Отменить",
    retry: "Повторить",
    pollDelayed: "Обновления задерживаются; подключаемся снова.",
    publicSearch: "Разрешить поиск в интернете",
    publicSearchDescription: "Запросы проходят проверку перед запуском. По умолчанию выключено.",
    context: "Добавить контекст · {{count}}",
    removeContext: "Убрать {{label}}",
    contextEmpty: "Пока нечего добавить.",
    contextLoading: "Загружаем вложения…",
    contextUnavailable: "Вложения недоступны.",
    contextMessage: "Сообщение из чата",
    uploadToDocuments: "Загрузить в документы",
    openDocuments: "Открыть документы",
    uploadPending: "Файл ещё проходит проверку. Удалите его или дождитесь доступа в Focus.",
    contextReasons: {
      uploading: "Загрузка",
      security: "Проверка безопасности",
      unsafe: "Небезопасный файл",
      unsupported: "Не поддерживается в Focus",
      blocked: "Доступ ИИ заблокирован",
    },
    composePlaceholder: "Задайте вопрос или опишите задачу…",
    send: "Отправить",
    copy: "Копировать",
    copied: "Скопировано",
    copyFailed: "Не удалось скопировать",
    sending: "Отправляем…",
    queryReview: "Проверка поиска в интернете",
    queryReviewDescription: "Одобрите или измените запросы до их запуска.",
    queryNumber: "Поиск {{number}}",
    approve: "Одобрить",
    saveQueries: "Сохранить правки",
    reject: "Отклонить",
    sources: "Источники",
    sourceLoading: "Загружаем источник…",
    reviewProposal: "Проверить изменение",
    proposalLoading: "Загружаем изменение…",
    proposalOperation: "Действие",
    proposalState: "Состояние",
    proposalOperations: {
      noteCreate: "Создание заметки",
      noteUpdate: "Изменение заметки",
      noteArchive: "Архивирование заметки",
      projectCreate: "Создание проекта",
      projectUpdate: "Изменение проекта",
      taskCreate: "Создание задачи",
      linkCreate: "Создание связи",
      linkRemove: "Удаление связи",
      documentPatch: "Изменение документа",
      documentReplace: "Замена документа",
      unknown: "Предлагаемое изменение",
    },
    proposalStates: {
      pending: "Ожидает проверки",
      blocked_by_edit_session: "Заблокировано активным редактором",
      applying: "Применяется",
      accepted: "Принято",
      rejected: "Отклонено",
      expired: "Истекло",
      conflict: "Конфликт",
      failed: "Ошибка",
      unknown: "Неизвестно",
    },
    acceptProposal: "Принять изменение",
    rejectProposal: "Отклонить изменение",
    requestFailed: "Не удалось выполнить действие. Обновите данные и повторите.",
    startFailed: "Не удалось запустить запрос.",
    partialStartFailed: "Чат создан, но запрос не запустился.",
    retryStart: "Повторить запрос",
    announceQueued: "Запрос поставлен в очередь.",
    announceQueryReview: "Поиск в интернете требует проверки.",
    announceCancelling: "Запрос отменяется.",
    announceConflict: "Состояние изменилось. Обновляем перед повтором.",
    announceState: "Состояние: {{state}}.",
    announceTerminal: "Готово: {{state}}.",
    readiness: {
      unpaired: "Не подключено",
      no_grant: "Нет доступа",
      offline: "Не в сети",
      model_unavailable: "Ассистент недоступен",
      ready: "Готово",
    },
    states: {
      queued: "в очереди",
      planning: "планирование",
      awaiting_query_review: "ожидает проверки",
      searching: "поиск в интернете",
      synthesizing: "подготовка ответа",
      cancelling: "отменяется",
      cancelled: "отменён",
      failed: "ошибка",
      interrupted: "прерван",
      succeeded: "готово",
    },
  },
  work: {
    title: "Работа",
    eyebrow: "Задачи",
    pageDescription: "Планируйте задачи.",
    createProject: "Новый проект",
    projectName: "Название проекта",
    timezoneLabel: "Часовой пояс",
    noWorkspace: "Нет рабочего пространства",
    noProjects: "Активных проектов нет",
    noProjectsTitle: "Проектов пока нет",
    noProjectsDescription: "Создайте первый проект, чтобы разместить в рабочем пространстве задачи.",
    noProjectsReadOnly: "В этом рабочем пространстве пока нет проектов. Первый проект может создать редактор пространства.",
    noTasks: "Здесь пока нет задач",
    noTasksForProjectTitle: "В этом проекте нет задач",
    noTasksForProjectDescription: "Добавьте первую задачу, чтобы начать работу с доской.",
    noTasksForProjectReadOnly: "В этом проекте пока нет задач. Первую задачу может добавить редактор пространства.",
    noMyTasksTitle: "На вас задач не назначено",
    noMyTasksDescription: "Выберите проект или откройте все задачи проектов, чтобы найти работу.",
    viewProjectTasks: "Открыть задачи проекта",
    noFilteredTasksTitle: "По этим фильтрам задач нет",
    noFilteredTasksDescription: "Измените фильтр статуса, названия или исполнителя.",
    clearFilters: "Сбросить фильтры",
    noDeadline: "Без срока",
    archivedState: "Задача в архиве",
    loading: "Загружаем задачи…",
    board: "Доска задач",
    project: "Проект",
    chooseProject: "Выберите проект",
    allProjects: "Все проекты",
    myTasks: "Мои задачи",
    boardView: "Доска",
    listView: "Список",
    filter: "Фильтр задач",
    filterPlaceholder: "Название задачи",
    statusFilter: "Статус",
    allStatuses: "Все статусы",
    quickCreate: "Добавить задачу",
    quickCreatePlaceholder: "Добавить задачу…",
    taskTitle: "Название задачи",
    status: "Статус",
    dropHere: "Перетащить сюда",
    drag: "Переместить",
    dragHandle: "Перетащить задачу",
    addTask: "Добавить задачу",
    move: "Переместить",
    moveTo: "Переместить в",
    assignees: "Исполнители: {{count}}",
    assignedToMe: "Назначено мне",
    comments: "Комментарии: {{count}}",
    taskDetail: "Детали задачи",
    description: "Описание",
    priority: "Приоритет",
    deadline: "Срок",
    assigneesInput: "Исполнители через запятую",
    assigneesPlaceholder: "Выберите аккаунты",
    labelsInput: "Метки через запятую",
    labelsPlaceholder: "например, исследование, важное",
    descriptionPreview: "Описание",
    commentsAndActivity: "Комментарии и история",
    commentPlaceholder: "Добавьте комментарий",
    addComment: "Добавить комментарий",
    loadMore: "Загрузить ещё",
    loadingMoreTasks: "Загружаем ещё задачи…",
    loadMoreTasks: "Загрузить ещё задачи",
    incompleteResults: "Доступны ещё задачи.",
    archive: "Архивировать",
    restore: "Восстановить",
    moveSaved: "Задача перемещена",
    moveConflict: "Доска изменилась. Загружены актуальные данные.",
    showInConnections: "Показать в связях",
    detailStates: {
      saved: "Все изменения сохранены.",
      unsaved: "Есть несохранённые изменения.",
      saving: "Сохраняем изменения…",
      stale: "Задача изменилась в другом месте. Загрузите актуальную версию и повторите.",
      forbidden: "Только просмотр. У вас нет права изменять эту задачу.",
    },
    loadMoreBeforeMove: "Загрузите все задачи проекта перед перемещением.",
    error: "Действие не выполнено",
    readOnly: "Только просмотр. Редактирование и комментарии отключены.",
    statuses: {
      inbox: "Входящие",
      planned: "Запланировано",
      inProgress: "В работе",
      review: "На проверке",
      done: "Готово",
    },
    priorities: {
      urgent: "Срочно",
      high: "Высокий",
      medium: "Средний",
      low: "Низкий",
      none: "Без приоритета",
    },
    activity: {
      created: "Создана",
      updated: "Изменена",
      ranked: "Перемещена",
      commented: "Добавлен комментарий",
      archived: "В архиве",
      restored: "Восстановлена",
    },
  },
  graph: {
    title: "Связи",
    chooseRoot: "Найти элемент",
    rootResults: "Результаты",
    loaded: "Показано {{loaded}} из {{available}}",
    truncated: "Некоторые связи скрыты.",
    semanticView: "Элементы и связи",
    nodes: "Элементы",
    edges: "Связи",
    node: "Элемент",
    edge: "Связь",
    actions: "Действия",
    expand: "Показать ещё",
    revisionLabel: "Версия",
    revision: "Версия {{revision}}",
    noWorkspace: "Нет рабочего пространства",
    noResults: "Совпадений нет: «{{query}}»",
    relationshipEditor: "Добавить связь",
    description: "Найдите связи между элементами.",
    searchPlaceholder: "Поиск по названию",
    searchHelp: "Введите название.",
    startEyebrow: "Начните здесь",
    startTitle: "Найдите элемент",
    startDescription: "Выберите элемент и следуйте его связям.",
    startSearchTitle: "Найти",
    startSearchDescription: "Ищите по названию.",
    startExploreTitle: "Перейти по связям",
    startExploreDescription: "Откройте связанные элементы.",
    openWork: "Открыть работу",
    openDocuments: "Открыть документы",
    openFocus: "Открыть Фокус",
    tryExample: "Попробовать пример",
    exampleEyebrow: "Тур по продукту",
    exampleTitle: "Пример графа",
    exampleDescription: "Выберите элемент для просмотра или покажите связи, чтобы продолжить путь.",
    exampleNotice: "Примерные данные — в рабочее пространство не сохраняются.",
    exampleScope: "{{count}} примеров элементов · данные пространства не изменены",
    returnToWorkspace: "Вернуться в пространство",
    exampleProject: "Пример проекта",
    exampleTask: "Пример задачи",
    exampleDocument: "Пример документа",
    exampleFocusThread: "Пример чата Фокуса",
    exampleAccount: "Пример аккаунта",
    startInspectTitle: "Проверить",
    startInspectDescription: "Выберите элемент, чтобы увидеть детали.",
    search: "Найти",
    searching: "Поиск…",
    loadMoreRoots: "Ещё результаты",
    showConnections: "Показать связи",
    showConnectionsFor: "Показать связи для",
    mapView: "Карта",
    listView: "Список",
    viewLabel: "Вид",
    zoomIn: "Увеличить",
    zoomOut: "Уменьшить",
    fitGraph: "Вписать граф",
    filters: "Фильтры",
    projectId: "Проект",
    accountId: "Аккаунт",
    tag: "Метка",
    includeArchived: "Включая архив",
    applyFilters: "Применить",
    clearFilters: "Очистить",
    root: "Начальный элемент",
    selectedNode: "Выбранный элемент",
    selectedEdge: "Выбранная связь",
    open: "Открыть",
    openIn: {
      work: "Открыть в работе",
      documents: "Открыть в документах",
      focus: "Открыть в Фокусе",
    },
    select: "Выбрать",
    noSelection: "Выберите элемент или связь.",
    nodeType: "Тип",
    edgeType: "Тип связи",
    source: "Откуда",
    target: "Куда",
    linkType: "Тип связи",
    createLink: "Добавить связь",
    removeLink: "Удалить связь",
    linkCreated: "Связь добавлена",
    linkRemoved: "Связь удалена",
    linkPending: "Сохраняем связь…",
    linkSaved: "Связь сохранена.",
    linkStale: "Граф изменился. Обновите связь и повторите.",
    linkForbidden: "У вас больше нет права изменять связи.",
    linkError: "Не удалось сохранить связь.",
    selfLink: "Выберите два разных элемента.",
    targetSearchPlaceholder: "Поиск доступных элементов",
    linkUnavailable: "Управлять связями могут только редакторы и владельцы.",
    noNodes: "Элементы не найдены",
    noEdges: "Связи не найдены",
    retry: "Повторить",
    nextPage: "Следующая страница",
    pageStatus: "Показано {{loaded}} из {{available}}",
    graphError: "Не удалось загрузить связи.",
    filterHint: "Дополнительные фильтры.",
    archived: "Архивный",
    yes: "Да",
    no: "Нет",
    nodeTypes: {
      note: "Заметка",
      project: "Проект",
      task: "Задача",
      document: "Документ",
      focus_thread: "Чат Фокуса",
      research_source: "Источник",
      account: "Аккаунт",
    },
    edgeTypes: {
      references: "Ссылается на",
      related_to: "Связан с",
      derived_from: "Происходит из",
      supports: "Поддерживает",
      assigned_to: "Назначено",
    },
    rootSearchError: "Поиск не выполнен.",
  },
  documents: {
    title: "Документы",
    eyebrow: "Файлы",
    pageDescription: "Проверенные файлы для Фокуса.",
    readyCount: "Проверено: {{count}}",
    empty: "Документов пока нет",
    emptyDescription: "Файлы проверяются перед использованием.",
    noResults: "Подходящих документов нет",
    loading: "Загружаем документы…",
    search: "Поиск",
    searchPlaceholder: "Найти документ…",
    filters: "Фильтры",
    all: "Все",
    readyFilter: "Готовы",
    scanningFilter: "Проверяются",
    attentionFilter: "Требуют внимания",
    sort: "Сортировка",
    modifiedRecently: "Недавно изменённые",
    upload: "Загрузить",
    uploadDocument: "Загрузить документ",
    chooseFile: "Выбрать файл",
    dropHint: "Перетащите файл или выберите его",
    uploadProgress: "Загружено {{percent}}% · проверка безопасности",
    uploadComplete: "Файл отправлен на проверку безопасности",
    uploadError: "Не удалось загрузить файл",
    refreshing: "Обновляем…",
    clearSearch: "Очистить поиск",
    listError: "Не удалось загрузить документы",
    searchError: "Не удалось выполнить поиск документов",
    errorDescription: "Файлы в безопасности. Повторите операцию.",
    uploadQueue: {
      title: "Очередь загрузки",
      count: "Файлов: {{count}}",
      submitted: "Отправлен как {{name}}",
      error: "Загрузка не удалась. Повторите или удалите файл.",
      open: "Открыть",
      retry: "Повторить загрузку",
      cancel: "Отменить загрузку",
      remove: "Удалить",
      states: {
        queued: "В очереди",
        hashing: "Проверяем хеш файла",
        uploading: "Загружаем",
        submitted: "Отправлен",
        error: "Ошибка загрузки",
        canceled: "Отменён",
      },
    },
    fileType: "Тип",
    state: "Состояние",
    capability: "Доступ для Фокуса",
    version: "Версия",
    modified: "Изменён",
    size: "Размер",
    open: "Открыть",
    download: "Скачать",
    history: "История версий",
    edit: "Редактировать",
    back: "Документы",
    selected: "Файл",
    metadata: "Сведения о файле",
    currentVersion: "Текущая версия",
    bytes: "Размер",
    opening: "Открытие",
    editing: "Редактирование",
    saving: "Сохранение",
    savedVersion: "Сохранено как версия {{version}}",
    saveDraft: "Сохранить черновик",
    saveVersion: "Сохранить версию",
    draftSaved: "Черновик сохранён",
    saveFailed: "Не удалось сохранить",
    draftSaveFailed: "Не удалось сохранить черновик",
    versionSaveFailed: "Не удалось сохранить версию",
    outputActionFailed: "Не удалось выполнить действие с результатом",
    saveConflict: "Конфликт сохранения",
    conflictTitle: "Документ изменился в другом месте",
    conflictDescription: "Черновик сохранён. Сравните изменения перед повторным сохранением.",
    compare: "Сравнить изменения",
    reloadVersion: "Загрузить версию заново",
    compareTitle: "Сравнение с текущей версией",
    compareDescription: "Сравните черновик с текущей версией перед сохранением.",
    preview: "Предпросмотр",
    showConnections: "Открыть в связях",
    downloadError: "Не удалось скачать файл",
    versionDownloadFailed: "Не удалось скачать эту версию",
    detailError: "Документ недоступен",
    detailErrorDescription: "Библиотека доступна. Вернитесь к документам или повторите загрузку.",
    downloadOnlyTitle: "Только скачивание",
    downloadOnlyDescription: "Для этого файла нет безопасного просмотра в браузере. Скачайте его для работы.",
    viewerUnavailable: "Файл проходит проверку безопасности. Предпросмотр появится после завершения.",
    viewerError: "Предпросмотр не загрузился",
    viewerErrorDescription: "Не удалось открыть защищённый просмотр.",
    source: "Исходник",
    requirements: "Требования к файлу",
    securityCheck: "Проверка безопасности",
    proposal: "Предлагаемое изменение",
    proposalText: "Проверить размер и целостность файла",
    proposalBasis: "Для версии {{version}}",
    removed: "Удалено",
    added: "Добавлено",
    acceptProposal: "Принять",
    rejectProposal: "Отклонить",
    stageOutput: "Проверить результат",
    discardOutput: "Удалить результат",
    versionCurrent: "Текущая",
    versionSource: "Исходник",
    versionUpload: "Загрузка",
    scannerUnavailable: "Проверка безопасности недоступна",
    unsafe: "Файл отклонён как небезопасный",
    scanning: "Сканирование",
    readOnlyAi: "Только чтение",
    readWrite: "Чтение и изменения",
    blocked: "Действия пока недоступны",
    gitStatus: "Состояние файла",
    gitConflict: "Локальные изменения конфликтуют с текущей версией",
    secureRedaction: "Проверенная защищённая копия",
    redactions: "Защищённые копии",
    noRedactions: "Защищённых копий нет",
    redactionDownloadFailed: "Не удалось скачать защищённую копию",
    redactionRegions: "Защищённых областей: {{count}}",
    redactionStates: {
      pending: "Ожидает проверки",
      verifying: "Проверяется",
      verified: "Проверена",
      rejected: "Отклонена",
    },
    officeLifecycle: "Защищённый редактор",
    officeOpening: "Подготовка редактора",
    officeEditorLoading: "Загрузка редактора",
    officeEditorReady: "Защищённый редактор готов",
    officeEditorError: "Не удалось открыть защищённый редактор",
    officeEditorAvailable: "Нажмите «Редактировать», чтобы открыть файл безопасно.",
    officeEditorErrorAction: "Редактор не загрузился. Повторите или закройте его.",
    officeFinalizeError: "Предыдущий сеанс редактора ещё закрывается.",
    officeFinalizeRetryAction: "Редактор закрылся до сохранения. Повторите закрытие.",
    officeFinalizeStalled: "Попробуйте позже.",
    officeFinalizing: "Сохранение изменений",
    officeRevoked: "Доступ к редактору отозван",
    officeSaveFailed: "Не удалось сохранить изменения",
    officeResetting: "Закрытие сеанса",
    officeResetError: "Не удалось закрыть сеанс. Повторите попытку.",
    officeResetAction: "Закрыть сеанс и отменить несохранённые изменения",
    editorStates: {
      opening: "Открытие редактора",
      active: "Защищённый редактор готов",
      saving: "Сохранение",
      finalizing: "Сохранение изменений",
      closed: "Редактор закрыт",
      save_failed: "Сохранение не выполнено",
      authorization_revoked: "Доступ к редактору отозван",
    },
    outputs: "Результаты",
    noOutputs: "Подготовленных результатов нет",
    retry: "Повторить проверку",
    close: "Закрыть",
    ingestStates: {
      uploading: "Загрузка",
      quarantined: "Ожидает проверки безопасности",
      scanning: "Проверяется",
      ready: "Готов",
      rejected_unsafe: "Небезопасен",
      failed_transient: "Ошибка проверки",
    },
    sourceTypes: {
      upload: "Загрузка",
      office: "Офисный редактор",
      markdown: "Исходник",
      proposal: "Предлагаемое изменение",
      git: "Репозиторий",
      recovery: "Восстановление",
    },
  },
  proposals: {
    title: "Предложения",
    blocked: "Заблокировано сеансом редактирования",
    conflict: "Конфликт с текущей версией",
    regenerate: "Пересоздать для версии {{version}}",
    pending: "Ожидает решения",
  },
  errors: {
    authRequired: "Требуется вход",
    staleRevision: "Объект уже изменён",
    staleBoardRevision: "Доска уже изменена",
    forbidden: "Недостаточно прав",
    invalidRequest: "Некорректный запрос",
    routeRejected: "Маршрут отклонён",
    mixedCredentials: "Нельзя смешивать типы учётных данных",
    invalidOrigin: "Источник запроса отклонён",
    browserCookieRejected: "Браузерная сессия здесь недопустима",
    deviceGrantRequired: "Требуется разрешение устройства",
    internalRouteRejected: "Внутренний маршрут недоступен",
    searchFailed: "Поиск завершился ошибкой",
    connectorOffline: "Подключение недоступно",
    saveConflict: "Сохранённая копия конфликтует с текущей версией",
    editSessionActive: "Документ открыт в редакторе",
    generic: "Произошла ошибка",
  },
  legal: {
    notice: "AGPL-3.0-only · Без гарантий · Исходный код",
  },
} as const;

export type TranslationShape<Value> = {
  readonly [Key in keyof Value]: Value[Key] extends string ? string : TranslationShape<Value[Key]>;
};
